<template>
    <div class="members-wrap">
        <div class="member-card_inner-link" v-for="member in members">
            <MembersItem
                :member="member"
                :active="user_is_active"
                :key="member.id"
            >
            </MembersItem>
        </div>
    </div>
</template>

<script>
    import MembersItem from "./MembersItem";
    export default {
        name: "MembersList",
        components: {
            MembersItem
        },
        props: {
            inner_members: {
                type: Array,
                required: false
            },
            user_is_active: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                members: this.inner_members
            }
        },
        watch: {
            inner_members(newVal, prevVal) {
                this.members = newVal;
            }
        }
    }
</script>

<style scoped>

</style>
